module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library5.b80a2eb2.png";